document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var slides = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-carousel-dot]'));
    var prevButton = carousel.querySelector('[data-carousel-prev]');
    var nextButton = carousel.querySelector('[data-carousel-next]');
    var index = 0;
    var autoAdvanceTimer;

    function goTo(newIndex) {
      index = (newIndex + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
      });
      slides.forEach(function (slide, slideIndex) {
        var slideVideo = slide.querySelector('video');
        if (!slideVideo) {
          return;
        }
        if (slideIndex === index) {
          slideVideo.play();
        } else {
          slideVideo.pause();
        }
      });
    }

    function goToFromUserAction(newIndex) {
      goTo(newIndex);
      var video = slides[index].querySelector('video');
      if (video) {
        video.muted = false;
        video.play();
      }
    }

    function startAutoAdvance() {
      autoAdvanceTimer = setInterval(function () {
        if (index >= slides.length - 1) {
          clearInterval(autoAdvanceTimer);
          return;
        }
        goTo(index + 1);
      }, 3000);
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        goToFromUserAction(index - 1);
      });
    }
    if (nextButton) {
      nextButton.addEventListener('click', function () {
        goToFromUserAction(index + 1);
      });
    }
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goToFromUserAction(parseInt(dot.dataset.index, 10));
      });
    });

    track.style.transition = 'transform 0.3s ease';
    goTo(0);
  });

  document.querySelectorAll('[data-bundle-builder]').forEach(function (builder) {
    var quantityEls = Array.prototype.slice.call(builder.querySelectorAll('[data-bundle-quantity]'));
    var countEl = builder.querySelector('[data-bundle-count]');
    var subtotalEl = builder.querySelector('[data-bundle-subtotal]');
    var discountLabelEl = builder.querySelector('[data-bundle-discount-label]');
    var discountAmountEl = builder.querySelector('[data-bundle-discount-amount]');
    var totalEl = builder.querySelector('[data-bundle-total]');
    var addButton = builder.querySelector('[data-bundle-add]');
    var messageEl = builder.querySelector('[data-bundle-message]');

    function formatMoney(amount) {
      return '$' + amount.toFixed(2);
    }

    function discountRate(totalQty) {
      if (totalQty >= 5) {
        return 0.15;
      }
      if (totalQty >= 3) {
        return 0.1;
      }
      return 0;
    }

    function update() {
      var totalQty = 0;
      var subtotal = 0;

      quantityEls.forEach(function (el) {
        var qty = parseInt(el.textContent, 10) || 0;
        var price = parseFloat(el.dataset.price) || 0;
        totalQty += qty;
        subtotal += qty * price;
      });

      var rate = discountRate(totalQty);
      var discountAmount = subtotal * rate;
      var total = subtotal - discountAmount;

      if (countEl) {
        countEl.textContent = totalQty;
      }
      if (subtotalEl) {
        subtotalEl.textContent = formatMoney(subtotal);
      }
      if (discountLabelEl) {
        discountLabelEl.textContent = rate > 0 ? 'Discount (' + rate * 100 + '%)' : 'Discount';
      }
      if (discountAmountEl) {
        discountAmountEl.textContent = '-' + formatMoney(discountAmount);
      }
      if (totalEl) {
        totalEl.textContent = formatMoney(total);
      }
      if (addButton) {
        addButton.disabled = totalQty === 0;
      }
    }

    builder.addEventListener('click', function (event) {
      var incrementTarget = event.target.closest('[data-bundle-increment]');
      var decrementTarget = event.target.closest('[data-bundle-decrement]');

      if (incrementTarget) {
        var incQtyEl = incrementTarget.parentElement.querySelector('[data-bundle-quantity]');
        incQtyEl.textContent = (parseInt(incQtyEl.textContent, 10) || 0) + 1;
        update();
      }

      if (decrementTarget) {
        var decQtyEl = decrementTarget.parentElement.querySelector('[data-bundle-quantity]');
        var current = parseInt(decQtyEl.textContent, 10) || 0;
        decQtyEl.textContent = Math.max(0, current - 1);
        update();
      }
    });

    if (addButton) {
      addButton.addEventListener('click', function () {
        var items = [];

        quantityEls.forEach(function (el) {
          var qty = parseInt(el.textContent, 10) || 0;
          if (qty > 0) {
            items.push({
              id: el.dataset.variantId.replace('gid://shopify/ProductVariant/', ''),
              quantity: qty,
            });
          }
        });

        if (items.length === 0) {
          return;
        }

        addButton.disabled = true;
        if (messageEl) {
          messageEl.hidden = true;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Add to cart failed');
            }
            return response.json();
          })
          .then(function () {
            quantityEls.forEach(function (el) {
              el.textContent = '0';
            });
            update();
            if (messageEl) {
              messageEl.textContent = 'Added to cart.';
              messageEl.hidden = false;
            }
          })
          .catch(function () {
            addButton.disabled = false;
            if (messageEl) {
              messageEl.textContent = 'Something went wrong. Please try again.';
              messageEl.hidden = false;
            }
          });
      });
    }

    update();
  });
});
